import React, { Component } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import SearchIcon from "@material-ui/icons/Search";
import StarIcon from "@material-ui/icons/Star";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import ChatIcon from "@material-ui/icons/Chat";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import GetAppIcon from "@material-ui/icons/GetApp";
import WarningIcon from '@material-ui/icons/Warning';
import ReplayIcon from '@material-ui/icons/Replay';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import FormatQuoteIcon from '@material-ui/icons/FormatQuote';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import GroupIcon from '@material-ui/icons/Group';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import LaunchOutlinedIcon from '@material-ui/icons/LaunchOutlined';
import TuneIcon from '@material-ui/icons/Tune';
import StopIcon from '@material-ui/icons/Stop';


export function CustomStopIcon (props:any) {
  return( <StopIcon {...props} />)
}

export class CustomLaunchOutlinedIcon extends Component {
  render(){
    return <LaunchOutlinedIcon {...this.props} />;
  }
}

export function CustomExpandMoreIcon(props:any) {
  return (
    <ExpandMoreIcon {...props} />
  )
}

export function CustomExpandLessIcon(props:any) {
  return (
    <ExpandLessIcon {...props} />
  )
}

export class CustomSearchIcon extends Component {
  render() {
    return <SearchIcon {...this.props} />;
  }
}

export function CustomStarIcon(props:any) {
  return (
    <StarIcon {...props} />
  )
}

export class CustomPlayCircleOutlineIcon extends Component {
  render() {
    return <PlayCircleOutlineIcon {...this.props} />;
  }
}

export class CustomHelpOutlineIcon extends Component {
  render() {
    return <HelpOutlineIcon {...this.props} />;
  }
}

export class CustomChatIcon extends Component {
  render() {
    return <ChatIcon {...this.props} />;
  }
}

export class CustomErrorOutlineIcon extends Component {
  render() {
    return <ErrorOutlineIcon {...this.props} />;
  }
}

export function CustomFiberManualRecordIcon (props:any) {
    return (<FiberManualRecordIcon {...props} />)
}

export function CustomCloseIcon (props:any) {
    return (<CloseIcon {...props} />)
}

export class CustomMenuIcon extends Component {
  render() {
    return <MenuIcon {...this.props} />;
  }
}

export class CustomGetAppIcon extends Component {
  render() {
    return <GetAppIcon {...this.props} />;
  }
}

export class CustomWarningIcon extends Component {
  render() {
    return <WarningIcon {...this.props} />;
  }
}

export class CustomReplayIcon extends Component {
  render() {
    return <ReplayIcon {...this.props} />;
  }
}

export class CustomKeyboardBackspaceIcon extends Component {
  render() {
    return <KeyboardBackspaceIcon {...this.props} />;
  }
}

export function CustomCheckCircleIcon (props:any) {
    return (<CheckCircleIcon {...props} />)
}

export class CustomFormatQuoteIcon extends Component {
  render() {
    return <FormatQuoteIcon {...this.props} />;
  }
}

export class CustomChevronRightIcon extends Component {
  render() {
    return <ChevronRightIcon {...this.props} />;
  }
}

export class CustomChevronLeftIcon extends Component {
  render() {
    return <ChevronLeftIcon {...this.props} />;
  }
}

export class CustomArrowDropDownIcon extends Component {
  render() {
    return <ArrowDropDownIcon {...this.props} />;
  }
}

export class CustomArrowRightIcon extends Component {
  render() {
    return <ArrowRightIcon {...this.props} />;
  }
}

export class CustomMoreVertIcon extends Component {
  render() {
    return <MoreVertIcon {...this.props} />;
  }
}

export function CustomUnfoldMoreIcon(props:any){
  return(
    <UnfoldMoreIcon {...props} />
  )
}

export class CustomGroupIcon extends Component {
  render() {
    return <GroupIcon {...this.props} />;
  }
}

export class CustomPeopleOutlineIcon extends Component {
  render() {
    return <PeopleOutlineIcon {...this.props} />;
  }
}

export class CustomFavoriteBorderIcon extends Component {
  render() {
    return <FavoriteBorderIcon {...this.props} />;
  }
}

export class CustomFavoriteIcon extends Component {
  render() {
    return <FavoriteIcon {...this.props} />;
  }
}

export class CustomPrintIcon extends Component {
  render() {
    return <PrintIcon {...this.props} />;
  }
}

export class CustomEditIcon extends Component {
  render() {
    return <EditIcon {...this.props} />;
  }
}

export class CustomDeleteOutlineIcon extends Component {
  render() {
    return <DeleteOutlineIcon {...this.props} />;
  }
}

export class CustomTuneIcon extends Component {
  render() {
    return <TuneIcon {...this.props} />;
  }
}